export default "__VITE_ASSET__DeksRQLo__"